module.exports = __webpack_public_path__ + "logo-io.svg?c9bf5923303207b11ea0fee28981ec0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-io.svg
// module id = 102
// module chunks = 0